import style from './Header.module.scss'
import burger from '../../../assets/imgs/header/menu-burger.svg'
import LogoutContainer from './Logout-Container'
import Avatar from '../Elements/Avatar/Avatar'
import { HeaderPropsType } from './Header-Container'
import logo from "../../../assets/imgs/logo/el_gran_kush/lg_blck_png.png"
import { NavLink } from 'react-router-dom'


const Header = (props: HeaderPropsType) => {

    let avatar = null
    // props.user && (avatar = props.user.profile.avatar)

    return (
        <header className={style.header}>
            <div className={style.container}>
                {/* <div className={style.menu}>
                    <img src={burger} alt="menu-burger" />
                </div> */}
                <NavLink className={style.companyName} replace to={'../'}>
                    <div className={style.brand}>
                        <div className={style.logo_wrapper}>
                            <img className={style.logo} src={logo} alt="" />
                        </div>

                        <h3 className={style.companyName}>El Gran Kush</h3>
                    </div>
                </NavLink>

                <div className={style.currentUser}>
                    <div className={style.name}>
                        {props.user && <LogoutContainer />}
                    </div>
                    {props.user && <Avatar
                        size={40}
                        // img={avatar}
                        link={'profile'}
                        user={props.user}
                    />}
                </div>
            </div>
        </header>
    )
}

export default Header